(function () {
  var btn = document.getElementById('dope-track-btn');
  var orderInput = document.getElementById('dope-order-number');
  var emailInput = document.getElementById('dope-order-email');
  var errorEl = document.getElementById('dope-track-error');
  var resultEl = document.getElementById('dope-track-result');
  var template = document.getElementById('dope-track-result-template');
  var WHATSAPP = 'https://wa.me/351936822694';

  if (!btn) return;

  function showError(text, withHelp) {
    errorEl.textContent = text;
    if (withHelp) {
      errorEl.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = WHATSAPP + '?text=' + encodeURIComponent('Hi DOPE, I want to track my order ' + (orderInput.value.trim() || ''));
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Message us on WhatsApp';
      a.style.color = 'inherit';
      a.style.textDecoration = 'underline';
      errorEl.appendChild(a);
      errorEl.appendChild(document.createTextNode(' and we will send you the tracking.'));
    }
    errorEl.hidden = false;
  }

  btn.addEventListener('click', function () {
    var orderNumber = orderInput.value.trim().replace(/^#/, '');
    var email = emailInput.value.trim();

    errorEl.hidden = true;
    resultEl.innerHTML = '';

    if (!orderNumber || !email) {
      showError('Please enter both your order number and email.', false);
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Searching...';

    var url = window.dopeTrackOrderProxyUrl
      + '?order=' + encodeURIComponent(orderNumber)
      + '&email=' + encodeURIComponent(email);

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (res.status === 404) throw new Error('not_found');
        if (!res.ok) throw new Error('service');
        var type = res.headers.get('content-type') || '';
        if (type.indexOf('json') < 0) throw new Error('service');
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.status) throw new Error('not_found');
        renderResult(data);
      })
      .catch(function (err) {
        if (err && err.message === 'not_found') {
          showError("We couldn't find an order with those details. Double check and try again, or", true);
        } else {
          showError('Order tracking is temporarily unavailable.', true);
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = 'Track order';
      });
  });

  function renderResult(data) {
    var node = template.content.cloneNode(true);

    node.querySelector('.dope-track__order-id').textContent = data.name;

    var badge = node.querySelector('.dope-track__badge');
    var desc = node.querySelector('.dope-track__desc');
    var dots = node.querySelectorAll('.dope-track__dot');
    var lines = node.querySelectorAll('.dope-track__line');
    var trackingRow = node.querySelector('.dope-track__tracking-row');
    var link = node.querySelector('.dope-track__link');

    var status = data.status;

    function showTracking() {
      if (data.trackingCompany || data.trackingNumber) {
        trackingRow.hidden = false;
        trackingRow.textContent = [data.trackingCompany, data.trackingNumber].filter(Boolean).join(' \u00b7 tracking ');
      }
      if (data.trackingUrl) {
        link.hidden = false;
        link.href = data.trackingUrl;
      }
    }

    if (status === 'preparing') {
      badge.textContent = 'Preparing your order';
      badge.classList.add('is-preparing');
      desc.textContent = "We've received your order and it's being packed with care.";
      dots[0].classList.add('is-done');
      dots[1].classList.add('is-current');
      lines[0].classList.add('is-done');
    }

    if (status === 'shipped') {
      badge.textContent = 'Shipped';
      badge.classList.add('is-shipped');
      desc.textContent = 'Your order is on its way.';
      dots[0].classList.add('is-done');
      dots[1].classList.add('is-done');
      dots[2].classList.add('is-current-shipped');
      lines[0].classList.add('is-done');
      lines[1].classList.add('is-done');
      showTracking();
    }

    if (status === 'delivered') {
      badge.textContent = 'Delivered';
      badge.classList.add('is-delivered');
      desc.textContent = 'Your order has been delivered. Enjoy!';
      dots.forEach(function (d) { d.classList.add('is-done'); });
      lines.forEach(function (l) { l.classList.add('is-done'); });
      showTracking();
    }

    resultEl.appendChild(node);
  }
})();
